import {baseEnvironment} from './environment.base';
export const environment = {
  ...baseEnvironment,
  API_URL: '/prodEnvUrl',
  dev: false,
  encryptLocalStorage: true,
  encryptLocalStorageKey: 'f74808fb03f94ef8f64350a37918c1b0518c',
  baseUrl: 'https://app.pcarelink.com/api/v1',
  instamed: {
    hostname: 'https://pay.instamed.com/',
    manual: false
  },
  openEdge: {
    payFieldsApiKey: 'T4An0sZ5hcZF1B43ZYtfSLw0ZWpcB5g8',
    environment: 'prod',
    enableAutocomplete: true
  },
  host: 'https://app.pcarelink.com',
  paymentHost: 'https://pay.pcarelink.com',
  inventoryURL: 'https://app.vaxintrack.com/admin/home/inventory',
  docUrl: 'https://docs.pcarelink.com/'
};
